import { useEffect } from 'react';

export const useBodyBackground = (backgroundColor: string) => {
  useEffect(() => {
    const originalBgColor = document.body.style.backgroundColor;
    const originalBgVar =
      document.body.style.getPropertyValue('--body-bg-color');

    document.body.style.backgroundColor = backgroundColor;
    document.body.style.setProperty('--body-bg-color', backgroundColor);

    return () => {
      document.body.style.backgroundColor = originalBgColor;
      document.body.style.setProperty('--body-bg-color', originalBgVar);
    };
  }, [backgroundColor]);
};
